export namespace ICookieBanner {
  export interface ICookieConfig {
    necessary: boolean;
    optional: boolean;
    gtm: boolean;
  }

  export enum ConfirmAction {
    Ignore = 'ignore',
    ConfirmAll = 'confirmAll',
    ConfirmSelected = 'confirmSelected',
    RejectAll = 'rejectAll',
  }

  export interface IStorageInfo {
    action: ConfirmAction;
    config: ICookieConfig;
  }

  export enum LocalStorageKeys {
    CookieBanner = 'cookieBanner:info',
  }

  export enum Event {
    ChangeCookieValue = 'cookieBanner:changeCookieValue',
  }
}